export default function nameCapitalize(string) {
  return string?.toLowerCase()
    .split(' ')
    .map((s) => s === 'de' || s === 'dos' || s === 'da' ? s : s.charAt(0).toUpperCase() + s.slice(1))
    .join(' ');
}